"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UIAccordionItem = _interopRequireDefault(require("UIComponents/accordion/UIAccordionItem"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var getDetails = function getDetails(error) {
  return error && error.data && JSON.parse(error.data).message;
};

var ErrorNotification = function ErrorNotification(_ref) {
  var error = _ref.action.payload.error;
  var details = getDetails(error);
  return _react.default.createElement("div", null, _react.default.createElement("span", null, _react.default.createElement(_FormattedMessage.default, {
    message: "marketing.ads.errors.genericError"
  })), details && _react.default.createElement(_UIAccordionItem.default, {
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "marketing.ads.errors.details"
    }),
    size: "extra-small"
  }, _react.default.createElement("p", null, details)));
};

ErrorNotification.propTypes = {
  action: _propTypes.default.object
};
var _default = ErrorNotification;
exports.default = _default;
module.exports = exports.default;